import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { CurrencyDisplayProps, CurrencyDisplay } from '@/components/localization';
import { Trans } from '@lingui/react/macro';

const ProfileCurrencyDisplay: React.FC<Omit<CurrencyDisplayProps, 'currency'>> = ({ ...rest }) => {
    const profile = useSelector((state: IState) => state.global.activeProfile);

    if (!profile || !profile.currencyCode) {
        return <Trans>Invalid currency</Trans>;
    }

    return (
        <CurrencyDisplay
            currency={profile.currencyCode}
            {...rest}
        />
    );
};

export default ProfileCurrencyDisplay;
